const StoreIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
    d="m24,7l-2.279-7H2.279L0,7c0,1.474.81,2.75,2,3.444v7.556H0v3c0,1.654,1.346,3,3,3h18c1.654,0,3-1.346,3-3v-3h-2v-7.556c1.19-.694,2-1.97,2-3.444ZM3.721,2h3.279v3h2v-3h6v3h2v-3h3.279l1.716,5.146c-.075,1.035-.941,1.854-1.995,1.854h-1c-1.103,0-2-.897-2-2h-2c0,1.103-.897,2-2,2h-2c-1.103,0-2-.897-2-2h-2c0,1.103-.897,2-2,2h-1c-1.054,0-1.92-.819-1.995-1.854l1.716-5.146Zm18.279,19c0,.551-.448,1-1,1H3c-.552,0-1-.449-1-1v-1h6.086l1,1h5.828l1-1h6.086v1Zm-2-3h-4.914l-1,1h-4.172l-1-1h-4.914v-7h1c1.201,0,2.266-.542,3-1.382.734.84,1.799,1.382,3,1.382h2c1.201,0,2.266-.542,3-1.382.734.84,1.799,1.382,3,1.382h1v7Z" />
  </svg>
);

export default StoreIcon;
